import { render, staticRenderFns } from "./PPMFilters.vue?vue&type=template&id=432b0c2c"
import script from "./PPMFilters.vue?vue&type=script&lang=ts"
export * from "./PPMFilters.vue?vue&type=script&lang=ts"
import style0 from "./PPMFilters.vue?vue&type=style&index=0&id=432b0c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports